/**************************************************
 * Nombre:       Home_Lineas
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {motion, useScroll, useTransform} from "framer-motion";
import iso from '../../../Recursos/iso.svg'
import {useContext, useEffect, useState} from "react";
import {contexApp} from "../../../App";

const Home_Lineas = () => {
    const cData = useContext(contexApp)
    const speed = 1;
    const {scrollY} = useScroll();
    const x = useTransform(scrollY, (value) => -value * speed);
    const y = useTransform(scrollY, (value) => value * speed);
    const [lineas, setLineas] = useState([])
    const [esBlack, setEsBlack] = useState(false)

    useEffect(() => {

        if (cData.configuraciones?.black === 'Si') {
            setLineas(listaBlack)
            setEsBlack(true)
        } else {
            setLineas(lista)
            setEsBlack(false)
        }

    }, [cData]);
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{overflowX: 'hidden', py: 0}}
        >

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{overflowX: 'hidden'}}>
                <Grid
                    component={motion.div}
                    container
                    justifyContent="flex-start"
                    alignItems="center"
                    sx={{
                        background: esBlack ? 'linear-gradient(90deg, #000 50.21%, #000 100%)' : 'linear-gradient(90deg, #6D5444 50.21%, #D3A283 100%)',
                        py: 1.5,
                        zIndex: 2,
                        minWidth: 4500,
                        maxLines: 1
                    }}
                    style={{x: x, transitionTimingFunction: "spring(1 100 10 10)", transition: "transform 3s"}}
                >

                    {lineas.map((item) => {
                        return (

                            <Typography
                                sx={{
                                    color: '#fff',
                                    mx: 0.2,
                                    fontSize: 14,
                                    maxLines: 1,
                                    fontWeight: esBlack ? 600 : 300,
                                    pl: 2,
                                    letterSpacing: 6,
                                }}>{item} <span><img src={iso} width={20} height={'auto'}
                                                     style={{marginTop: 4, marginBottom: -4}}/></span> </Typography>


                        )
                    })}


                </Grid>

            </Grid>


        </Grid>
    )

}
export default Home_Lineas

const listaBlack = ['BLACK DAYS -20%OFF EN TODA LA TIENDA', 'BLACK DAYS -20%OFF EN TODA LA TIENDA', 'BLACK DAYS -20%OFF EN TODA LA TIENDA', 'BLACK DAYS -20%OFF EN TODA LA TIENDA', 'BLACK DAYS -20%OFF EN TODA LA TIENDA', 'BLACK DAYS -20%OFF EN TODA LA TIENDA', 'BLACK DAYS -20%OFF EN TODA LA TIENDA']

const lista = ['ERES LUZ Y UN ALMA VIVA LISTA PARA BRILLAR', 'VIVE CON PASIÓN , VÍSTETE  CON ALMA', 'ERES LUZ Y UN ALMA VIVA LISTA PARA BRILLAR', 'VIVE CON PASIÓN, VISTETE CON ALMA', 'ERES LUZ Y UN ALMA VIVA LISTA PARA BRILLAR', 'VIVE CON PASIÓN, VISTETE CON ALMA',]